export default __webpack_public_path__ + "static/media/Helm of the Refectory.80ee3e85.jpg";